module.exports = __webpack_public_path__ + "assets/img/sbp.e870ad2a.svg";